// __BUILD_* globals are declared in src/types/env.d.ts.
import { readEnv } from '@/shared/lib/util/runtimeEnv';

// webpack's DefinePlugin substitutes these (webpack/common.config.ts). `yarn build:debug` replaces
// the whole plugin list, which leaves them undeclared — and a bare reference to an undeclared
// identifier throws ReferenceError at import time, taking the app down. `typeof` is the one form
// that is safe on an undeclared name, so read them through it.
const buildInfo = {
  commit: typeof __BUILD_COMMIT === 'string' ? __BUILD_COMMIT.substring(0, 7) : 'unknown',
  version: typeof __BUILD_VERSION === 'string' ? __BUILD_VERSION : 'unknown',
  appVersion: typeof __APP_VERSION === 'string' ? __APP_VERSION : 'unknown',
  branch: typeof __BUILD_BRANCH === 'string' ? __BUILD_BRANCH : 'unknown',
  date: typeof __BUILD_DATE === 'string' ? __BUILD_DATE : ''
};

export default {
  // BASEPATH: process.env.BASEPATH,
  // process.env.BASEPATH gives problems; after a lot of
  // troubleshooting on 4/29/2022 could not figure out the
  // root cause, assigning '/' directly as a workaround
  BASEPATH: '/',
  DEFAULT_PATH: readEnv('DEFAULT_PATH') || '/home',
  BUILD_COMMIT: buildInfo.commit,
  BUILD_VERSION: buildInfo.version,
  APP_VERSION: buildInfo.appVersion,
  BUILD_BRANCH: buildInfo.branch,
  BUILD_DATE: buildInfo.date,
  GRAPHQL_ENDPOINT: readEnv('GRAPHQL_ENDPOINT'),
  WEBSOCKET_URL: readEnv('WEBSOCKET_URL') || '',
  // Full origin for the chart-access pages, e.g. "https://rx.qa.truentity.net". When set it is
  // used verbatim (so the URL need not contain the legacy `server` label). When empty, the base
  // is derived from the API host by prepending CHARTS_SUBDOMAIN (see getChartsBaseUrl).
  CHARTS_BASE_URL: readEnv('CHARTS_BASE_URL') || '',
  CHARTS_SUBDOMAIN: readEnv('CHARTS_SUBDOMAIN') || 'rx',
  CHARTS_URL_PREFIX: readEnv('CHARTS_URL_PREFIX') || 'charts',
  INACTIVITY_TIMEOUT_S: 900,
  INACTIVITY_PROMPT_TIMEOUT_S: 60,
  REAUTH_GRACE_PERIOD_S: 7200,
  MIN_INACTIVITY_TIMEOUT_S: 300,
  MAX_INACTIVITY_TIMEOUT_S: 14400,
  MIN_PIN_PROMPT_TIMEOUT_S: 30,
  MAX_PIN_PROMPT_TIMEOUT_S: 900,
  POLLING_INTERVAL_MS: 5000,
  APOLLO_LINK_TIMEOUT_S: 360,
  CACHE_POLICY: readEnv('CACHE_POLICY') || 'cache-first',
  DEBUG_LAYOUT: false,
  FEATURE_ACTION_CABLED_ENABLED: readEnv('FEATURE_ACTION_CABLED_ENABLED') || 'true',
  TRUENTITY_INITIAL_VISIT_URL: readEnv('TRUENTITY_INITIAL_VISIT_URL'),
  TRUENTITY_FOLLOWUP_VISIT_URL: readEnv('TRUENTITY_FOLLOWUP_VISIT_URL'),
  MUI_LICENSE_KEY: readEnv('MUI_LICENSE_KEY') || ''
};
